<div
  class="full-height full-width shape"
  longPress
  (shortPress)="onSeatShortPress()"
  (longPress)="onSeatLongPress()"
  [style.transform]="dataObject?.rotate ? 'rotate(' + dataObject?.rotate + 'deg)' : 'none'"
  [style.background-image]='dataObject | svgToBase64Bg : shape'
>
  @if (shapeSeatTypeUtils.isVisualShape(shape)) {
    <div
      class="position-absolute full-width full-height d-flex align-items-center justify-content-center"
    ></div>
  } @else if (dataObject.seatStatusKey === seatStatuses.FREE && !dataObject.loveSeatId && !isLegendShape && shapeSeatTypeUtils.resolve(shape.shapeSeatType) !== shapeSeatTypes.DISABLED && terminalParametersMap()[terminalParameterKeys.WEB_CASH_SHOW_SEATS_NUMBERS]) {
    <div
      class="position-absolute seat-nr white-space-nowrap"
      [style.transform]="dataObject?.rotate ? 'translateX(-50%) rotate(' + (-dataObject.rotate) + 'deg)' : null"
      [appContrastText]="dataObject.priceAreaColor ?? shape.color"
      darkColor="#0E3758"
    >
      {{ dataObject.seatNumber }}
    </div>
  }
</div>
